import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import { SMSConversationsManager } from "@/components/admin/SMSConversationsManager";

const SMSConversations = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <>
      <SEOHead 
        title="SMS Conversations"
        description="Manage SMS conversations and messages"
      />
      
      <SMSConversationsManager />
    </>
  );
};

export default SMSConversations;
